module.exports = __webpack_public_path__ + "img/camera_off.26129984.png";